import classNames from "classnames";
import React from "react";

interface DiscountBadgeProps {
  percentage: number;
  className?: string;
  mode?: "dark" | "light";
}

interface OptionsBadgeProps {
  options: number;
  className?: string;
}

const DiscountBadge: React.FC<DiscountBadgeProps> = ({ percentage, className, mode = "light" }) => {
  return (
    <div
      className={classNames(
        "rounded-[30px] px-2 py-0.5 text-xxxs  font-semibold flex whitespace-nowrap mb-0.5",
        className,
        {
          "bg-discount-badge text-white": mode === "dark",
          "bg-discount-badge bg-opacity-[0.1] text-discount-badge ": mode === "light",
        }
      )}
    >
      {percentage}% OFF
    </div>
  );
};

const DiscountBadgeImage: React.FC<DiscountBadgeProps> = ({ percentage, className, mode = "light" }) => {
  return (
    <div
      className={classNames(
        "rounded-[5px] px-2 py-1 text-xxs font-semibold flex whitespace-nowrap mb-0.5 items-center",
        className,
        {
          "bg-discount-badge text-white": mode === "dark",
          "bg-discount-badge bg-opacity-[0.1] text-discount-badge ": mode === "light",
        }
      )}
    >
      {percentage}% OFF
    </div>
  );
};

const OptionsBadge: React.FC<OptionsBadgeProps> = ({ options, className }) => {
  return (
    <div
      className={classNames(
        "items-center gap-x-1 rounded-lg px-1.75 py-1 sm:px-2 sm:py-1.25 text-xs border border-grey-fields-100 font-semibold inline-flex bg-discount-badge bg-opacity-[0.1] text-discount-badge",
        className
      )}
    >
      {/* prettier-ignore */}
      {/* <svg width="14" viewBox="0 0 10 11" fill="none">
        <path d="M7.77917 1.33333H6.98751C6.07917 1.33333 5.60001 1.8125 5.60001 2.72083V3.5125C5.60001 4.42083 6.07917 4.9 6.98751 4.9H7.77917C8.68751 4.9 9.16667 4.42083 9.16667 3.5125V2.72083C9.16667 1.8125 8.68751 1.33333 7.77917 1.33333Z" fill="currentColor"/>
        <path d="M3.01668 6.09583H2.22501C1.31251 6.09583 0.833344 6.575 0.833344 7.48333V8.275C0.833344 9.1875 1.31251 9.66667 2.22084 9.66667H3.01251C3.92084 9.66667 4.40001 9.1875 4.40001 8.27917V7.4875C4.40418 6.575 3.92501 6.09583 3.01668 6.09583Z" fill="currentColor"/>
        <path d="M2.62084 4.90833C3.60805 4.90833 4.40834 4.10804 4.40834 3.12083C4.40834 2.13362 3.60805 1.33333 2.62084 1.33333C1.63363 1.33333 0.833344 2.13362 0.833344 3.12083C0.833344 4.10804 1.63363 4.90833 2.62084 4.90833Z" fill="currentColor"/>
        <path d="M7.37917 9.66667C8.36638 9.66667 9.16667 8.86637 9.16667 7.87916C9.16667 6.89196 8.36638 6.09167 7.37917 6.09167C6.39197 6.09167 5.59167 6.89196 5.59167 7.87916C5.59167 8.86637 6.39197 9.66667 7.37917 9.66667Z" fill="currentColor"/>
      </svg> */}
      {/* <svg width="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM17 17.25H7C6.59 17.25 6.25 16.91 6.25 16.5C6.25 16.09 6.59 15.75 7 15.75H17C17.41 15.75 17.75 16.09 17.75 16.5C17.75 16.91 17.41 17.25 17 17.25ZM17 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H17C17.41 11.25 17.75 11.59 17.75 12C17.75 12.41 17.41 12.75 17 12.75ZM17 8.25H7C6.59 8.25 6.25 7.91 6.25 7.5C6.25 7.09 6.59 6.75 7 6.75H17C17.41 6.75 17.75 7.09 17.75 7.5C17.75 7.91 17.41 8.25 17 8.25Z"
          fill="currentColor"
        />
      </svg> */}
      {/* prettier-ignore */}
      {/* <svg width="16" viewBox="0 0 24 24" fill="none">
        <path opacity="0.4" d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z" fill="currentColor"/>
        <path d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z" fill="currentColor"/>
        <path d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z" fill="currentColor"/>
        <path opacity="0.4" d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z" fill="currentColor"/>
      </svg> */}

      <span>
        {/* {options} {options > 1 ? "Options" : "Option"} */}
        Has Options
      </span>
    </div>
  );
};

export { DiscountBadge, OptionsBadge, DiscountBadgeImage };
